import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=6c295ae2&"
import script from "./MiPerfil.vue?vue&type=script&lang=js&"
export * from "./MiPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports